import { render, staticRenderFns } from "./InsuranceType.vue?vue&type=template&id=c10dd516&"
import script from "./InsuranceType.vue?vue&type=script&lang=js&"
export * from "./InsuranceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports